import WithTrackProvider from '@/components/WithTrackProvider'
import goTo from '@/libs/functions/goTo'
import { TrackView } from '@dragonpass/intl-unified-tracker'
import { Button, Dialog, Popup, Space } from 'antd-mobile'
import { useEffect, useState } from 'react'

export default function DpTracker() {
  const [modalVisible, setModalVisible] = useState(false)

  const handleClick = () => {
    window.dpTracker?.sendClk({
      eventData: {
        module_name: 'demo',
        component_name: 'click',
      },
    })
  }

  const handleLogin = () => {
    window.dpTracker?.identify({
      user_id: 'test_user_id',
      identity_mp_openid: 'test_identity_mp_openid',
      DPID: 'test_DPID',
      app_name: 'test_app_name',
      app_version: '0.0.1',
    })
  }

  const handlePageViewTest = () => {
    window.dpTracker?.sendPage({
      publicParams: {
        page_name: '测试页面',
      },
    })
  }

  useEffect(() => {
    window.dpTracker?.sendPage({
      publicParams: {
        page_name: 'spmB1',
      },
    })

    return () => {
      window.dpTracker?.sendPageEnd()
    }
  }, [])

  return (
    <TrackView
      trackData={{
        module_name: 'demo',
        component_name: 'demo_div',
      }}
      trackClk={false}
      component="div"
      id="demo-lagyout"
    >
      <Space
        wrap
        style={{
          width: '100%',
        }}
      >
        <Button color="primary" onClick={handleClick}>
          click
        </Button>
        <Button color="primary" onClick={handleLogin}>
          登录或者免登
        </Button>
        <Button
          color="primary"
          onClick={() => {
            goTo('/demo/storageError')
          }}
        >
          跳转
        </Button>
        <Button color="primary" onClick={handlePageViewTest}>
          pageView
        </Button>
        <Button color="primary" onClick={() => setModalVisible(true)}>
          NoDestoryModal
        </Button>
        <Button
          color="primary"
          onClick={() => {
            Dialog.show({
              title: '权益激活',
              content: (
                <WithTrackProvider>
                  <TrackView
                    component="div"
                    trackClk={false}
                    trackData={{
                      module_name: 'demo_dialog',
                      component_name: 'body',
                    }}
                  >
                    <div>
                      <div>权益过期时间：2023-01-01</div>
                    </div>
                  </TrackView>
                </WithTrackProvider>
              ),
              getContainer: () => document.getElementById('demo-lagyout'),
              actions: [
                [
                  {
                    key: 'cancel',
                    text: '取消',
                    onClick: () => {
                      window.dpTracker?.sendClk({
                        eventData: {
                          module_name: 'demo_dialog',
                          coponent_name: '关闭按钮',
                        },
                      })
                      Dialog.clear()
                    },
                    style: {
                      color: '#202020',
                      fontSize: 15,
                    },
                  },
                  {
                    key: 'delete',
                    text: '确定激活',
                    style: { fontSize: 15 },
                    onClick: () => {
                      window.dpTracker?.sendClk({
                        eventData: {
                          module_name: 'demo_dialog',
                          coponent_name: '确认激活',
                        },
                      })
                      Dialog.clear()
                    },
                    // onClick: Dialog.confirm,
                  },
                ],
              ],
            })
          }}
        >
          Dialog.show
        </Button>
      </Space>
      <NoDestoryPopup
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </TrackView>
  )
}

function NoDestoryPopup(props: { visible: boolean; onClose(): void }) {
  return (
    <Popup
      showCloseButton
      visible={props.visible}
      onClose={() => props.onClose()}
    >
      <TrackView
        trackData={{
          module_name: 'demo_popup',
          component_name: 'demo_popup_body',
        }}
        trackClk={false}
      >
        <div>content.....</div>
        <div>content.....</div>
        <div>content.....</div>
        <div>content.....</div>
        <div>content.....</div>
        <div>content.....</div>
      </TrackView>
    </Popup>
  )
}
